module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module3-1.0ae4c20e.jpg";